<template>
  <div class="top-menu">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="work" class="work-menu">工作台</el-menu-item>
      <el-menu-item index="prescription" class="user-menu"
        >处方管理</el-menu-item
      >
      <el-menu-item index="user" class="user-menu">个人中心</el-menu-item>
      <el-tooltip
        effect="dark"
        class="my-new"
        content="我的消息"
        placement="bottom"
      >
        <el-button class="item" type="primary" @click="message()">
          <el-badge
            :value="msgIsRead > 99 ? '99+' : msgIsRead"
            v-if="msgIsRead != 0"
          >
            <i class="el-icon-message-solid"></i>
          </el-badge>
          <i class="el-icon-message-solid" v-else></i>
        </el-button>
      </el-tooltip>
      <el-tooltip effect="dark" :content="fullscreenText" placement="bottom">
        <el-button class="switch-btn" type="primary" @click="screen()">
          <i v-show="!fullscreen" class="el-icon-rank"></i>
          <img
            v-show="fullscreen"
            class="el-icon-rank1"
            src="../../assets/images/zoom.png"
            alt
          />
        </el-button>
      </el-tooltip>
      <el-tooltip effect="dark" content="锁屏" placement="bottom">
        <el-button class="lock-btn" disabled type="primary" @click="lock()">
          <i v-show="isLock" class="el-icon-lock"></i>
          <i v-show="!isLock" class="el-icon-unlock"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip effect="dark" content="退出" placement="bottom">
        <el-button class="out-btn" type="primary" @click="out()">
          <i class="el-icon-switch-button"></i>
        </el-button>
      </el-tooltip>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import cookie from "@/utils/cookie.js";
import util from "@/utils";
export default {
  name: "tabs",
  props: {
    editableTabs: Array,
  },
  data() {
    return {
      activeIndex: "work",
      editableTab: this.editableTabs,
      isLock: true,
      fullscreen: false,
      fullscreenText: "全屏",
      passwd: "",
      box: false,
    };
  },
  computed: {
    ...mapGetters(["lockPasswd"]),
    ...mapState(["status", "profileStep"]),

    msgIsRead() {
      return this.$store.state.msgIsRead;
    },
  },

  mounted() {},
  created() {
    this.getUrl();
    /*
     * 全屏状态下监听Esc事件
     */
    let that = this;

    document.addEventListener("fullscreenchange", () => {
      let isFullscreen =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.fullScreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen;
      that.fullscreen = !!isFullscreen;
      that.fullscreenText = that.fullscreen == true ? "退出全屏" : "全屏";
    });
    // document.addEventListener("mozfullscreenchange", () => {
    //   that.fullscreen = !that.fullscreen;
    // });
    // document.addEventListener("webkitfullscreenchange", () => {
    //   that.fullscreen = !that.fullscreen;
    // });
    // document.addEventListener("msfullscreenchange", () => {
    //   that.fullscreen = !that.fullscreen;
    // });
  },
  methods: {
    /**
     * @param {Object} key
     * @param {Object} 暴露出去的路由
     */
    handleSelect(key, keyPath) {
      if (key === "work") {
        this.$router.push({
          path: "/index/work/patients",
        });
      } else if (key === "prescription") {
        this.$router.push({
          path: "/index/user/prescription",
        });
      } else {
        // this.$router.push({
        //   path: "/index/user/auditInformation/auditInfo",
        // });
        this.$router.push({
          path: "/index/user/userinfo",
        });
      }
      var urlName = "";
      // switch (key) {
      //   case "user":
      //     console.log("user:",key);
      //     console.log("this.status:",this.status);
      //     console.log("this.profileStep:",this.profileStep);
      //     if (this.status === 0) {
      //       //待审核
      //       urlName = "/index/user/auditInformation/auditInfo";
      //       if (this.profileStep === 1 || this.profileStep === 2 || this.profileStep === 3){
      //         urlName = "/index/user/auditInformation/information";
      //       }
      //     }else if(this.status === 1){
      //       //审核通过
      //       urlName = "/index/user/auditInformation/information";
      //     }else if(this.status === -1) {
      //       //审核拒绝
      //       urlName = "/index/user/auditInformation/auditInfo";
      //     }
      //     console.log(urlName);

      //     break;
      //   case "":
      //     break;
      //   default:
      //     urlName = "/index/work/patients";
      //     break;
      // }
      // console.log(urlName);
      // this.$router.push({
      //   path: urlName,
      // });
      // this.$router.push({
      //   path: "/index/user/auditInformation/auditInfo",
      // });
    },
    go(url) {
      this.$router.push({
        path: url,
      });
    },
    /**
     * 通过获取路由最后地址来更改导航高亮
     */
    getUrl() {
      let currentUrl = window.location.href;
      if (currentUrl.split("#")[1].split("/")[3] === "prescription") {
        this.activeIndex = currentUrl.split("#")[1].split("/")[3];
      } else {
        this.activeIndex = currentUrl.split("#")[1].split("/")[2];
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 切换全屏
     */
    screen() {
      const that = this;
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      let isFullscreen =
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.fullScreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen;
      that.fullscreen = !!isFullscreen;
      that.fullscreenText = that.fullscreen == true ? "退出全屏" : "全屏";
    },
    /**
     * 锁屏功能
     */
    lock() {
      const that = this;
      this.$confirm("开启锁屏, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //锁屏状态0，不允许跳转
          util.setStore("lockState", "0");
          util.setStore("lockPrePath", this.$route.path);
          that.elementTips("success", "锁屏成功");
          setTimeout(() => {
            // that.go("/lock");
            location.reload(true); //刷新页面路由守卫会让其跳转到锁屏页面
          }, 100);
        })
        .catch(() => {
          that.elementTips("info", "锁屏失败");
        });
    },

    /**
     * 退出功能
     */
    out() {
      const that = this;
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          util.removeStore("user_token");
          util.removeStore("username");
          util.removeStore("userInfo");
          util.removeStore("user_id");
          util.removeStore("userType");
          util.removeStore("user_mobile");
          cookie.delCookie("uid");
          cookie.delCookie("sdktoken");
          that.elementTips("success", "退出成功");
          setTimeout(function () {
            that.go("/login");
            that.$store.dispatch("logout");
          }, 2000);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    message() {
      const that = this;
      that.go("/index/user/news");
    },
  },
  watch: {
    /**
     * 监听路由变化，修改标题高亮指向
     * 为了解决首页点击消息进入user页面标题不对应问题
     * 缺点：但是只要路由变化就执行方法
     */
    $route: function () {
      this.getUrl();
    },
  },
};
</script>
<style scoped lang="scss">
.switch-btn,
.lock-btn,
.out-btn,
.my-new {
  background: #ffffff !important;
  border: #ffffff !important;
  color: #a19a9a !important;
}

.el-icon-rank1 {
  color: #a19a9a !important;
}

.top-menu ul {
  display: flex;
  justify-content: center;
}

.top-menu .item {
  margin-right: 40px;
  position: absolute;
  right: 190px;
  text-align: center;
  font-size: 20px;
  /* padding: 2px 3px; */
  line-height: 30px;
  height: 100%;
}

.top-menu .el-icon-message-solid:before {
  content: "\E799";
  color: #a19a9a;
}

.top-menu .item-btn {
  position: absolute;
  right: 250px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}

.top-menu .switch-btn {
  position: absolute;
  right: 90px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}
.top-menu .switch-btn img {
  width: 20px;
  height: 20px;
}

.top-menu .lock-btn {
  position: absolute;
  right: 160px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}

.top-menu .out-btn {
  position: absolute;
  right: 20px;
  text-align: center;
  font-size: 20px;
  line-height: 15px;
  height: 100%;
}

.work-menu {
  width: 127.97px;
  position: relative;
  left: 30px;
}

.work-menu:focus {
  background: #ffffff;
  color: #fc701a !important;
  border-bottom: none !important;
}

.el-menu-demo .el-menu-item.is-active {
  color: #fc701a !important;
  font-weight: bold !important;
  border: none;
}

.el-menu-demo .el-menu-item:focus {
  color: #fc701a !important;
}

.work-menu.is-active:after {
  content: "";
  display: block;
  position: relative;
  left: 19px;
  bottom: 10px;
  width: 30px;
  border-bottom: 3px solid #fc701a;
}

.user-menu.is-active:after {
  content: "";
  display: block;
  position: relative;
  left: 30px;
  bottom: 10px;
  width: 30px;
  border-bottom: 3px solid #fc701a;
}
</style>
